import * as yup from 'yup';

export const AssertionEditorValidationSchema = yup.object({
	initialVal: yup.string().required('assertions.validation.initial_value_required'),
	replaceVal: yup.string().required('assertions.validation.replaced_value_required'),
});
